import { momentLocalizer, Formats } from 'react-big-calendar';
import moment from 'moment';
import 'moment-timezone';

moment.tz.setDefault('Etc/UTC');
moment.updateLocale('Etc/UTC', {
  week: {
    dow: 1, // First day of week is Monday
    doy: 4, // First week of year must contain 4 January (7 + 1 - 4)
  },
});

export const localizer = momentLocalizer(moment);

export const formats: Formats = {
  timeGutterFormat: 'h aaa',
};
